import { sentenceCase } from 'change-case'
import { SalaryType } from '../generated/graphql'

export const formatSalaryType = (salaryType: SalaryType) => {
  return sentenceCase(salaryType)
}
